module.exports = {
  baseUrl: "https://api.exam-assistant.prathameshramane.com",
};
